import { render, staticRenderFns } from "./ContratosAtivosInativos.vue?vue&type=template&id=677242f4"
import script from "./ContratosAtivosInativos.vue?vue&type=script&lang=js"
export * from "./ContratosAtivosInativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports